import classNames from 'classnames/bind';

import styles from './S01.module.scss';

import background from '../../../assets/images/products/barrel/s01/background.jpg';
import bubble_left from '../../../assets/images/products/barrel/s01/bubble_left.png';
import bubble_right from '../../../assets/images/products/barrel/s01/bubble_right.png';
import leaf_left from '../../../assets/images/products/barrel/s01/leaf_left.png';
import leaf_right from '../../../assets/images/products/barrel/s01/leaf_right.png';
import product from '../../../assets/images/products/barrel/s01/product.png';

const cx = classNames.bind(styles);

const S01 = () => {
  return (
    <div className={cx('container')} style={{ backgroundImage: `url(${background})` }}>
      <div className={cx('limiter')}>
        <h2 className={cx('title')}>자연의 깨끗함을 담은 물</h2>
        <p className={cx('text')}>
          풀무원샘물은 청정 자연에서 취수한 물을 엄격한 관리 기준으로 담아냅니다.
          <br />
          프리미엄 대용량 먹는샘물을 신선하고 편리하게 즐길 수 있습니다.
        </p>
      </div>
      <div className={cx('objects')}>
        <img className={cx('left')} src={leaf_left} alt="" />
        <img className={cx('right')} src={leaf_right} alt="" />
        <img className={cx('bubbleLeft')} src={bubble_left} alt="" />
        <img className={cx('bubbleRight')} src={bubble_right} alt="" />
      </div>
      <img className={cx('product')} src={product} alt="풀무원샘물 15L" />
    </div>
  );
};

export default S01;
